import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07dd4894"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "campaign-complete"
}
const _hoisted_2 = { id: "campaign-complete-media-container" }
const _hoisted_3 = {
  id: "campaign-complete-info-container",
  class: "w-full"
}
const _hoisted_4 = { id: "campaign-complete-info" }
const _hoisted_5 = { id: "campaign-complete-info-header" }
const _hoisted_6 = { id: "campaign-complete-info-header-title" }
const _hoisted_7 = { id: "campaign-complete-info-header-subtitle" }
const _hoisted_8 = ["data-creator-address", "data-tweet-subtext"]
const _hoisted_9 = { id: "campaign-complete-info-summary-countdown-action" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "BURN TO REDEEM", -1))

import { Interface } from '@ethersproject/abi';
import JSConfetti from 'js-confetti';
import {
  computed, ref, watch,
} from 'vue';
import { useMutation } from 'vue-query';
import erc721Abi from '@manifoldxyz/typed-contracts/abis/ERC721Contract.json';
import erc1155Abi from '@manifoldxyz/typed-contracts/abis/ERC1155Contract.json';
import apiHelpers from '@/api/apiHelpers';
import Creator1155Contract from '@/classes/creator1155Contract';
import Action from '@/components/Action.vue';
import Description from '@/components/Description.vue';
import BurnSummary from '@/components/BurnSummary.vue';
import Countdown from '@/components/Countdown.vue';
import Footer from '@/components/Footer.vue';
import Frame from '@/components/Frame.vue';
import MediaLoader from '@/components/MediaLoader.vue';
import TokenSelectorDialog from '@/components/TokenSelectorDialog.vue';
import Provenance, { Record } from '@/components/Provenance.vue';
import Seller from '@/components/Seller.vue';
import { useAccount } from '@/composables/useAccount';
import {
  abbreviateAddress, abbreviate, NFTMetadata, sleep, ultraAbbreviateAddress,
} from '@/lib/util';
import { AuthState } from '@/store/modules/account.store';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { BigNumber } from '@ethersproject/bignumber';
import { useInjectTopLevelProps } from '@/exports/MBurnRedeemCompleteWidgetProps';
import { BurnRedeemStudioInstance } from '@/api/models/burnRedeem';
import { ModuleBRModule } from '@/store/modules/br.store';
import {
  DataClientNFT, NULL_BYTES32, Step,
} from '@/common/constants';
import { MerkleTree } from 'merkletreejs';
import { pack } from '@ethersproject/solidity';
import CreatorContract from '@/classes/creatorContract';
import {
  BurnRedeemOnChain,
  BurnToken,
} from '@/classes/burnRedeemExtensionCore';
import { parseEthersTransactionError, EthersTransactionError } from '@/common/web3TransactionErrorHandling';
import { TransactionReceipt } from '@ethersproject/abstract-provider';

/*
 * @dev: In order for keccak256 to work we must shim Buffer
 */
import { Buffer } from 'buffer';
import keccak256 from 'keccak256';
import { useBR } from '@/composables/useBR';

export default /*#__PURE__*/_defineComponent({
  __name: 'BurnCompleteBody',
  props: {
    burnRedeemStudioInstance: null,
    redeemAssetMetadata: null
  },
  setup(__props: any) {

const props = __props as {
  burnRedeemStudioInstance?: BurnRedeemStudioInstance;
  redeemAssetMetadata: NFTMetadata;
};

window.Buffer = window.Buffer || Buffer;



// @dev: network is renamed to avoid confustion with the network ref from useAccount()
const { network: propsNetwork } = useInjectTopLevelProps();
// @dev: network is renamed to avoid confustion with the network ref from useInjectTopLevelProps()
const { authState, walletAddress, network: accountNetwork, isProviderAvailable, client } = useAccount();
const {
  status, contractsToApprove, redeemContractAddress,
  redeemSpec, extensionVersion, extensionFees, burn,
  extensionContract, extensionAddress, burnRedeemIndex,
} = useBR();

const burnRedeemTxErrorMsg = ref('');
const burnFee = ref<BigNumber>(BigNumber.from(0));
const showTokenSelectorDialog = ref(false);
const showConfirmationModal = ref(false);
const txHash = ref('');
const mintedTokenId = ref('');
const selectedTokens = ref<DataClientNFT[][]>([[]]);
const eligibleBurnTokens = ref<DataClientNFT[][]>([[]]);
const usedBurnTokens = ref<DataClientNFT[]>([]);
const isRefreshingWeb3State = ref(false);

const steps = ref<Step[]>([]);

const regenerateSteps = () => {
  const totalSteps = contractsToApprove.value.length + 1;
  steps.value = [];
  for (let i = 0; i < contractsToApprove.value.length; i++) {
    steps.value.push({
      name: `${i + 1}/${totalSteps} APPROVE TOKENS FOR BURN`,
      description: `Confirm the transaction in your wallet to approve your tokens from ${ultraAbbreviateAddress(contractsToApprove.value[i])} for burning.`,
      status: 'next',
      href: '#',
    });
    steps.value.push({
      name: `${i + 1}/${totalSteps} APPROVE TOKENS FOR BURNING`,
      description: `Approving your tokens from ${ultraAbbreviateAddress(contractsToApprove.value[i])} for burning...`,
      status: 'next',
      href: '#',
    });
  }

  steps.value.push({
    name: `${totalSteps}/${totalSteps} BURN REDEEM`,
    description: `Please sign the transaction with your wallet to finalize your Burn Redeem.`,
    status: 'next',
    href: '#',
  });

  steps.value.push({
    name: `${totalSteps}/${totalSteps} BURN REDEEM`,
    description: `Awaiting blockchain confirmation of your Burn Redeem, please wait...`,
    status: 'next',
    href: '#',
  });
};

const numberToRedeem = computed(() => {
  let amount = 0;

  if (!burn.value || !selectedTokens.value.length) {
    return amount;
  }


  let divisor = burn.value.burnSet[0].items[0].amount.toNumber();
  divisor = divisor === 0 ? 1 : divisor;

  // we can just inspect the first step/group since they should all align

  for (let i = 0; i < selectedTokens.value[0].length; i++) {
    amount +=  parseInt(selectedTokens.value[0][i].count) / divisor;
  }

  return amount;
});

const burnLimitType = computed((): string => {
  if (!burn.value) {
    return 'unknown';
  } else if (burn.value.totalSupply === 0) {
    return 'open';
  } else {
    return 'limited';
  }
});


const allowBurning = computed(() => {
  if (isRefreshingWeb3State.value) {
    return false;
  }

  if (burnRedeemStatus.value === 'loading') {
    return false;
  }

  if (supplyLeft.value < 1 && burnLimitType.value !== 'open') {
    return false;
  }

  if (isUsingInvalidNetwork()) {
    return false;
  }

  // eligibleBurnTokensis a 2D array so we need to check if any
  // if the INNER arrays are empty, as that signifies they own no
  // eligible burn tokens for that burn step aka burn group.
  if (eligibleBurnTokens.value.find((tokens) => tokens.length === 0)) {
    return false;
  }


  if (!burn.value) {
    return false;
  }

  // if they can satisfy the first step in the burn set at all, they can burn
  for (let i = 0; i < eligibleBurnTokens.value[0].length; i++) {
    const iOwn = parseInt(eligibleBurnTokens.value[0][i].count);
    const iNeed = burn.value.burnSet[0].items[0].amount.toNumber();
    if (iOwn >= iNeed) {
      return true;
    }
  }

  // if they have gotten here, they cannot satisfy the first burn step and cannot burn
  return false;
});

const supplyLeft = computed(() => {
  return burn.value && burn.value.totalSupply !== 0
    ? burn.value.totalSupply - burn.value.redeemedCount
    : 0;
});

// when they log in, scroll them to the top of the page
watch(authState, async () => {
  if (authState.value === AuthState.LOGGED_IN) {
    setTimeout(() => {
      if (window.innerWidth <= 640) {
        window.scrollTo({
          top: window.innerHeight * 0.5,
          behavior: 'smooth',
        });
      }
    }, 200);
    await refreshWeb3States();
  }
});

watch(accountNetwork, async () => {
  await refreshWeb3States();
});

watch(isProviderAvailable, async () => {
  if (isProviderAvailable) {
    await refreshWeb3States();
  }
});

const logTransaction = (hash: string): void => {
  apiHelpers
    .post('/public/instance/tx', {}, {
      'appId': '2534903479',
      'instanceId': props.burnRedeemStudioInstance?.id || '',
      'hash': hash,
    })
    .then(() => {
      // Do nothing
    })
    .catch(() => {
      // Do nothing
    });
};

const isUsingInvalidNetwork = () : boolean => {
  return !!(accountNetwork.value && accountNetwork.value !== propsNetwork);
};

const throwIfInvalidNetwork = (): void => {
  if (isUsingInvalidNetwork()) {
    throw new Error(`Wrong network. Please switch to ${
      propsNetwork === 1 ? 'Mainnet' : 'Goerli'
    } network to continue.`);
  }
};

const callToAction = () => {
  // regenerate the burn redeem tx steps
  regenerateSteps();
  // zero out any previous error warnings
  burnRedeemTxErrorMsg.value = '';
  showTokenSelectorDialog.value = true;

};

const openConfirmationModal = async () => {
  burnRedeemTxErrorMsg.value = '';
  showTokenSelectorDialog.value = false;
  showConfirmationModal.value = !showConfirmationModal.value;
};

const parseMintedTokenIdFromBRReceiptWithLogs = (receipt: TransactionReceipt) => {
  if (receipt && receipt.logs) {
    let newId = '';
    for (const log of receipt.logs) {
      try {
        const theABI = redeemSpec.value === 'erc721' ? erc721Abi : erc1155Abi;
        const iface = new Interface(theABI); // @dev: the ABI of the token we transfer to you
        const parsed = iface.parseLog(log);
        if (parsed.args.to.toLowerCase() === walletAddress.value?.toLowerCase()) {
          newId = parsed.args.tokenId?.toString() || parsed.args.id?.toString();
          break;
        }
      } catch (e) {
        // Do nothing, log will failed parse for events specific to extension contract
      }
    }

    mintedTokenId.value = newId;
  }
};

const refreshWeb3States = async () => {
  throwIfInvalidNetwork();

  isRefreshingWeb3State.value = true;

  try {
    await ModuleBRModule.refreshBurnRedeemOnChain();
  } catch (e) {
    console.warn('Error refreshing states', e);
  }

  try {
    await getBurnableNFTsWithClientForBurnSet();
  } catch (e) {
    console.warn('Error refreshing states', e);
  }

  isRefreshingWeb3State.value = false;
};

const getBurnableNFTsWithClientForBurnSet = async (): Promise<void> => {
  if (client.value && burn.value?.burnSet && burn.value?.burnSet.length) {
    for (let i = 0; i < burn.value.burnSet.length; i++) {
      const theGroup = burn.value.burnSet[i];
      let filters = [];

      for (let j = 0; j < theGroup.items.length; j++) {
        const theItem = theGroup.items[j];
        if (theItem.validationType === 1) {
          filters.push({ contractAddress: theItem.contractAddress });
        }

        if (theItem.validationType === 2) {
          filters.push({
            contractAddress: theItem.contractAddress,
            minTokenId: theItem.minTokenId?.toString(),
            maxTokenId: theItem.maxTokenId?.toString(),
          });
        }

        if (props.burnRedeemStudioInstance?.publicData?.burnSet?.length) {
          if (theItem.validationType === 3) {
            filters.push({
              contractAddress: theItem.contractAddress,
              tokenIds: props.burnRedeemStudioInstance.publicData.burnSet[i].items[0].tokenIds,
            });
          }
        }
      }


      // @dev: we make make one request per burn group so the data is associated to that group index
      eligibleBurnTokens.value[i] = await client.value.getNFTsOfOwner({ filters: filters }) as DataClientNFT[];

      // remove any tokens previously burnt in this session
      for (let j = 0; j < usedBurnTokens.value.length; j++) {
        const usedToken = usedBurnTokens.value[j];
        const eligibleTokens = eligibleBurnTokens.value[i];
        const eligibleTokenIndex = eligibleTokens.findIndex((token) => {
          return twoTokensAreTheSame(token, usedToken);
        });

        // @dev: if the token is 1155 we reduce the count, if it is 721 we remove it
        if (eligibleTokenIndex !== -1) {
          if (usedToken.spec === 'erc1155') {
            eligibleTokens[eligibleTokenIndex].count = (parseInt(eligibleTokens[eligibleTokenIndex].count) - parseInt(usedToken.count)).toString();
          } else {
            eligibleTokens.splice(eligibleTokenIndex, 1);
          }
        }
      }

      // @TODO: we should remove all tokens that were created using the BR itself by checking on chain
    }
  }
};

const getBurnTokensParameter = (): BurnToken[] => {
  let burnTokens: BurnToken[] = [];

  if (!burn.value?.burnSet || !props.burnRedeemStudioInstance?.publicData?.burnSet) {
    return burnTokens;
  }

  for (let i = 0; i < selectedTokens.value.length; i++) {
    const selectedTokensForGroup = selectedTokens.value[i];
    // @WARN: WE HARDCODE AND ASSUME THERE'S ONLY ONE ITEM TO LOOK AT
    const selectedGroupOnChain = burn.value.burnSet[i];
    const selectedItemOnChain = selectedGroupOnChain.items[0];

    for (let j = 0; j < selectedTokensForGroup.length; j++) {
      const selectedToken = selectedTokensForGroup[j];
      let merkleProof = [NULL_BYTES32];

      // @dev: For validation type 3, we need to generate a merkle proof
      if (selectedItemOnChain.validationType === 3) {
        const tokenIds = props.burnRedeemStudioInstance?.publicData?.burnSet[i].items[j].tokenIds;
        const leaves = tokenIds?.map((x: string) => pack(['uint256'], [x])) || [];
        const tree = new MerkleTree(leaves, keccak256, {
          hashLeaves: true,
          sortPairs: true,
        });
        const leaf = keccak256(pack(['uint256'], [selectedToken.tokenId]));
        merkleProof = tree.getHexProof(leaf);

        const root = '0x' + tree.getRoot().toString('hex'); // bytes32 must start with 0x in ethers
        if (root !== (burn.value as BurnRedeemOnChain).burnSet[i].items[0].merkleRoot) {
          // this means somehow our two trees dont match
          throw new Error('Merkle root mismatch! Contact support');
        }

        const validity = tree.verify(
          merkleProof,
          leaf.toString('hex'),
          tree.getRoot().toString('hex'),
        );

        if (!validity) {
          throw new Error('Merkle root invalid! Contact support');
        }
      }

      burnTokens.push({
        contractAddress: selectedToken.contractAddress,
        id: selectedToken.tokenId,
        groupIndex: i,
        // @WARN @DEV: WE HARDCODE AND ASSUME THERE'S ONLY ONE ITEM TO LOOK AT
        itemIndex: 0,
        merkleProof: merkleProof,
      });
    }
  }

  return burnTokens;
};

const getBurnTokensParameterOverloaded = (): BurnToken[][] => {
  const burnTokens: BurnToken[][] = [];
  for (let i = 0; i < numberToRedeem.value; i++) {
    burnTokens.push([]);
  }

  if (!burn.value?.burnSet || !props.burnRedeemStudioInstance?.publicData?.burnSet) {
    return [];
  }

  // for each of the 1155s in the selectedTokens array or arrays,
  // we need to create a burn token for each of the numberToRedeem
  for (let i = 0; i < selectedTokens.value.length; i++) {
    const selectedTokensForGroup = selectedTokens.value[i];

    // @WARN: WE HARDCODE AND ASSUME THERE'S ONLY ONE ITEM TO LOOK AT
    const selectedGroupOnChain = burn.value.burnSet[i];
    const selectedItemOnChain = selectedGroupOnChain.items[0];
    // go through every selected token in selected tokens
    for (let j = 0; j < selectedTokensForGroup.length; j++) {
      const selectedToken = selectedTokensForGroup[j];
      let merkleProof = [NULL_BYTES32];

      // @dev: For validation type 3 generate a merkle proof
      if (selectedItemOnChain.validationType === 3) {
        const tokenIds = props.burnRedeemStudioInstance?.publicData?.burnSet[i].items[j].tokenIds;
        const leaves = tokenIds?.map((x: string) => pack(['uint256'], [x])) || [];
        const tree = new MerkleTree(leaves, keccak256, {
          hashLeaves: true,
          sortPairs: true,
        });
        const leaf = keccak256(pack(['uint256'], [selectedToken.tokenId]));
        merkleProof = tree.getHexProof(leaf);

        const root = '0x' + tree.getRoot().toString('hex'); // bytes32 must start with 0x in ethers
        if (root !== (burn.value as BurnRedeemOnChain).burnSet[i].items[0].merkleRoot) {
          // this means somehow our two trees dont match
          throw new Error('Merkle root mismatch! Contact support');
        }

        const validity = tree.verify(
          merkleProof,
          leaf.toString('hex'),
          tree.getRoot().toString('hex'),
        );

        if (!validity) {
          throw new Error('Merkle root invalid! Contact support');
        }
      }

      if (selectedToken.spec === 'erc1155') {
        // if the token is an erc1155, we need to create its burn token for each redemption
        for (let k = 0; k < numberToRedeem.value; k++) {
          burnTokens[k].push({
            contractAddress: selectedToken.contractAddress,
            id: selectedToken.tokenId,
            groupIndex: i,
            // @WARN @DEV: WE HARDCODE AND ASSUME THERE'S ONLY ONE ITEM TO LOOK AT
            itemIndex: 0,
            merkleProof: merkleProof,
          });
        }
      } else {
        // if the token is an erc721, we only need to create one burn token
        // the index in the burnTokens array is same as its index in selectedTokensForGroup
        burnTokens[j].push({
          contractAddress: selectedToken.contractAddress,
          id: selectedToken.tokenId,
          groupIndex: i,
          // @WARN @DEV: WE HARDCODE AND ASSUME THERE'S ONLY ONE ITEM TO LOOK AT
          itemIndex: 0,
          merkleProof: merkleProof,
        });
      }
    }
  }

  return burnTokens;
};

const twoTokensAreTheSame = (token1: DataClientNFT, token2: DataClientNFT) => {
  return token1.tokenId === token2.tokenId && token1.contractAddress === token2.contractAddress;
};

const onBurnRedeemSuccess = async () => {
  for (let i = 0; i < selectedTokens.value.length; i++) {
    for (let j = 0; j < selectedTokens.value[i].length; j++) {
      const selectedToken = selectedTokens.value[i][j];
      const preExistingTokenInUsedBurnTokens = usedBurnTokens.value.findIndex((token) => {
        return twoTokensAreTheSame(token, selectedToken);
      });

      if (preExistingTokenInUsedBurnTokens > -1) {
        usedBurnTokens.value[preExistingTokenInUsedBurnTokens].count =
          (parseInt(usedBurnTokens.value[preExistingTokenInUsedBurnTokens].count)
          + parseInt(selectedToken.count)).toString();
      } else {
        usedBurnTokens.value.push(selectedToken);
      }
    }
  }

  // Reset the UX
  showConfirmationModal.value = false;
  selectedTokens.value = [[]];
  new JSConfetti().addConfetti({
    emojis: ['🔥🎉'],
    confettiRadius: 90,
    confettiNumber: 200,
  });

  // this will update the TOTAL REDEEMED and BURNABLE BALANCE
  await refreshWeb3States();

  // fire analytics last so we dont block the UX on analytics processing
  try {
    // eslint-disable-next-line
    // @ts-ignore - because plausible is injected and so not defined per-se
    plausible('Burned');
  } catch (e) {
    console.warn(e);
  }

  // scroll to bottom of campaign campaign info container so user sees the two links
  window.setTimeout(() => {
    const el = document.querySelector('#campaign-complete-info-container');
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, 500);
};

const onBurnRedeemError = async (error: unknown) => {
  const err = error as EthersTransactionError;
  burnRedeemTxErrorMsg.value = parseEthersTransactionError(err);

  if (err.replacement && !err.cancelled) {
    // @dev: it was actually successful, just replaced via speeding up the tx
    const tx = err.replacement;
    const receipt = await tx.wait(1);
    txHash.value = receipt.transactionHash;
    parseMintedTokenIdFromBRReceiptWithLogs(receipt);
    await onBurnRedeemSuccess();
  } else {
    // @dev: it was not successful, reset the state
    txHash.value = '';
    showConfirmationModal.value = false;
  }
};

/**
 * This is an extremely key part of this file, it handles burning to redeem.
 * To call it, you use the mutatation handler mutateBurnRedeem()
 *
 * After being called it will automatically update burnRedeemStatus to either "error", "loading",
 * "idle" or "success". It uses onSuccess and onError handlers to make the UX react.
 */
const {
  status: burnRedeemStatus,
  mutate: mutateBurnRedeem,
} = useMutation(async () => {
  // hide the selection modal, they've confirmed
  showTokenSelectorDialog.value = false;
  // clear any previous tx hashes
  txHash.value = '';

  // reset the pending modal's steps
  steps.value[0].status = 'current';
  for (let i = 1; i < steps.value.length; i++ ) {
    steps.value[i].status = 'next';
  }

  throwIfInvalidNetwork();

  if (burnLimitType.value !== 'open' && supplyLeft.value === 0) {
    throw new Error('No more tokens to burn');
  }

  if (!extensionContract.value) {
    throw new Error('Unable to burn tokens with missing contract instance');
  }

  // ensure burn data is up to date
  try {
    await refreshWeb3States();
  } catch {
    throw new Error('Unable to burn.');
  }

  let response;

  // legacy v1.0 burn
  if (
    extensionVersion.value === 'v1.0' &&
    walletAddress.value &&
    burn.value &&
    burn.value.burnSet &&
    burn.value.burnSet.length === 1 &&
    burn.value.burnSet[0].items[0].minTokenId &&
    burn.value.burnSet[0].items[0].amount &&
    redeemSpec.value === 'erc1155'
  ) {
    // @dev: we skip the 0th and 1st step on Legacy since approval is NOT needed!
    steps.value[0].status = 'complete';
    steps.value[1].status = 'complete';

    steps.value[2].status = 'current';

    const creator1155BurnTokenContract = new Creator1155Contract(
      burn.value.burnSet[0].items[0].contractAddress,
    );

    response = await creator1155BurnTokenContract.transferToExtensionAndBurn(
      walletAddress.value,
      burn.value.burnSet[0].items[0].minTokenId.toString(),
      extensionAddress.value,
      numberToRedeem.value * burn.value.burnSet[0].items[0].amount?.toNumber(),
      {
        mintToAddress: walletAddress.value,
        creatorContractAddress: redeemContractAddress.value,
        index: burnRedeemIndex.value,
        amount: numberToRedeem.value,
      },
    );
    steps.value[2].status = 'complete';
    steps.value[3].status = 'current';
  }

  // v2.0 and v3.0 burn
  else if (
    (
      extensionVersion.value === 'v2.0'
      || extensionVersion.value === 'v3.0'
      || extensionVersion.value === 'v3.1'
    ) &&
    extensionContract &&
    walletAddress.value &&
    burn.value
  ) {
    const creatorBurnContracts = contractsToApprove.value.map((address) => {
      return new CreatorContract(address);
    });

    // one group means use the normal fee, multiple groups means use the higher fee
    if (eligibleBurnTokens.value.length === 1) {
      burnFee.value = extensionFees.value.single.mul(numberToRedeem.value);
    } else {
      burnFee.value = extensionFees.value.set.mul(numberToRedeem.value);
    }

    for (let i = 0; i < creatorBurnContracts.length; i++) {
      steps.value[i * 2].status = 'current';
      const approveRes = await creatorBurnContracts[i].setApprovalForAll(
        walletAddress.value,
        extensionAddress.value,
      );
      steps.value[i * 2].status = 'complete';

      steps.value[(i * 2) + 1].status = 'current';
      if (approveRes) {
        steps.value[(i * 2) + 1].href = `https://${propsNetwork === 5 ? 'goerli.' : 'www.'}etherscan.io/tx/${
          approveRes.hash
        }`;
        if (!isProviderAvailable) {
          await sleep(60000);
        } else {
          await approveRes.wait(1);
        }
      }
      steps.value[(i * 2) + 1].status = 'complete';
    }

    steps.value[steps.value.length - 2].status = 'current';
    const burnTokensParam: BurnToken[] = getBurnTokensParameter();

    // @dev: Multi-redeem branching logic
    if (numberToRedeem.value > 1 && burnTokensParam.length > 1) {
      // @dev: get the parameters for the overloaded version of burnRedeem
      let multiRedeemBurnTokensParam = getBurnTokensParameterOverloaded();
      response = await (extensionContract.value).burnRedeemOverload(
        walletAddress.value,
        Array(numberToRedeem.value).fill(redeemContractAddress.value),
        Array(numberToRedeem.value).fill(burnRedeemIndex.value),
        Array(numberToRedeem.value).fill(1), // @dev: each redemption is for one mint
        multiRedeemBurnTokensParam,
        burnFee.value ? burnFee.value.toString() : '0',
        burn.value.cost ? burn.value.cost.toString() : '0',
      );
    } else {
      response = await (extensionContract.value).burnRedeem(
        walletAddress.value,
        redeemContractAddress.value,
        burnRedeemIndex.value,
        numberToRedeem.value.toString(),
        burnTokensParam,
        burnFee.value ? burnFee.value.toString() : '0',
        burn.value.cost ? burn.value.cost.toString() : '0',
      );
    }

    steps.value[steps.value.length - 2].status = 'complete';
  }

  steps.value[steps.value.length - 1].status = 'current';
  if (!response) {
    throw new Error('Error: No response from blockchain transaction');
  }
  logTransaction(response.hash);

  // @dev: This should always return false for WalletConnect
  if (!isProviderAvailable) {
    /**
     * @WARN
     *
     * This is a hack!
     *
     * When transacting without a provider (e.g. WalletConnect) we
     * actually do NOT have the ability to wait until the tx has been
     * mined, nor parse the logs of that tx after it gets mined.
     *
     * Pausing 60s here allows us to have a good chance that the block will be
     * mined before a UI updates, avoiding a number of confusing UI edge cases.
     * We simply do not report back to the user any information that would've
     * been found within the logs of the tx.
     */
    await sleep(60000);
  } else {
    // parse the logs using the provider
    txHash.value = response.hash;
    // show this as the last step's href
    steps.value[steps.value.length - 1].href = `https://${propsNetwork === 5 ? 'goerli.' : 'www.'}etherscan.io/tx/${
      response.hash
    }`;

    const receipt = await response.wait(1);
    parseMintedTokenIdFromBRReceiptWithLogs(receipt);
  }
},
{
  onError: onBurnRedeemError,
  onSuccess: onBurnRedeemSuccess,
},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, null, {
    default: _withCtx(() => [
      (_unref(burn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (props.redeemAssetMetadata)
                ? (_openBlock(), _createBlock(MediaLoader, {
                    key: 0,
                    id: "campaign-complete-media",
                    image: 
            props.burnRedeemStudioInstance?.publicData?.image || props.redeemAssetMetadata.image
          ,
                    media: 
            props.burnRedeemStudioInstance?.publicData?.redeemAssetMedia ??
              props.redeemAssetMetadata.animation_url
          ,
                    "show-download": true,
                    "show-links": true,
                    "show-video-controls": true
                  }, {
                    error: _withCtx(() => [
                      _createTextVNode(" Failed to load media ")
                    ]),
                    _: 1
                  }, 8, ["image", "media"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h1", _hoisted_6, _toDisplayString(props.burnRedeemStudioInstance?.publicData?.name || props.redeemAssetMetadata.name), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (props.burnRedeemStudioInstance?.creator?.address)
                      ? (_openBlock(), _createBlock(Seller, {
                          key: 0,
                          id: "campaign-complete-info-header-artist",
                          address: props.burnRedeemStudioInstance.creator.address
                        }, null, 8, ["address"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      id: "campaign-complete-info-header-subscribe",
                      "data-widget": "m-widget-subscribe",
                      "data-creator-address": props.burnRedeemStudioInstance?.creator?.address,
                      "data-tweet-subtext": `%0A%0Ahttps://app.manifold.xyz/br/${props.burnRedeemStudioInstance?.slug}?utm_source=subscribed_tweet`
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(Description, {
                    id: "campaign-complete-info-description",
                    description: 
                props.burnRedeemStudioInstance?.publicData?.description ||
                  props.redeemAssetMetadata.description
              
                  }, null, 8, ["description"]),
                  (_unref(status) === 'not-started' && _unref(burn)?.startDate > 0)
                    ? (_openBlock(), _createBlock(Countdown, {
                        key: 0,
                        id: "campaign-complete-info-countdown",
                        "end-date": new Date(_unref(burn)?.startDate * 1000),
                        label: "starts in"
                      }, null, 8, ["end-date"]))
                    : _createCommentVNode("", true),
                  (_unref(status) === 'enabled' && _unref(burn)?.endDate > 0)
                    ? (_openBlock(), _createBlock(Countdown, {
                        key: 1,
                        id: "campaign-complete-info-countdown",
                        "end-date": new Date(_unref(burn)?.endDate * 1000)
                      }, null, 8, ["end-date"]))
                    : _createCommentVNode("", true),
                  (_unref(burn))
                    ? (_openBlock(), _createBlock(BurnSummary, {
                        key: 2,
                        id: "campaign-complete-info-summary",
                        "redeem-asset-metadata": __props.redeemAssetMetadata,
                        "redeem-token-name": props.burnRedeemStudioInstance?.publicData?.redeemTokenName
                      }, null, 8, ["redeem-asset-metadata", "redeem-token-name"]))
                    : _createCommentVNode("", true),
                  (_unref(burn) && _unref(redeemContractAddress))
                    ? (_openBlock(), _createBlock(Action, {
                        key: 3,
                        id: "campaign-complete-info-action",
                        "error-msg": burnRedeemTxErrorMsg.value,
                        status: _unref(status),
                        "supply-left": _unref(supplyLeft),
                        "number-to-redeem": _unref(numberToRedeem),
                        "allow-burning": _unref(allowBurning),
                        "burn-redeem-tx-status": _unref(burnRedeemStatus),
                        "tx-hash": txHash.value,
                        "minted-token-id": mintedTokenId.value,
                        onCallToAction: callToAction
                      }, null, 8, ["error-msg", "status", "supply-left", "number-to-redeem", "allow-burning", "burn-redeem-tx-status", "tx-hash", "minted-token-id"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(Provenance, {
                  id: "provenance-container",
                  records: ([
              __props.redeemAssetMetadata ? {
                label: 'Original Media',
                link: __props.redeemAssetMetadata.animation_url || __props.redeemAssetMetadata.image,
                value: _unref(abbreviate)(__props.redeemAssetMetadata.animation_url || __props.redeemAssetMetadata.image),
              } : undefined,
              _unref(redeemContractAddress) ? {
                label: 'Redeem Contract',
                link: `https://${_unref(propsNetwork) === 5 ? 'goerli.' : 'www.'}etherscan.io/address/${_unref(redeemContractAddress)}`,
                value: _unref(abbreviateAddress)(_unref(redeemContractAddress))
              } : undefined,
              _unref(burn).startDate ? {
                label: 'Start Date',
                value: (new Date(_unref(burn).startDate * 1000)).toLocaleString(),
              } : undefined,
              {
                label: 'End Date',
                value: _unref(burn).endDate ? (new Date(_unref(burn).endDate * 1000)).toLocaleString() : 'Never'
              },
              {
                label: 'Redeem Token Type',
                value: _unref(redeemSpec)?.toUpperCase()
              }
            ].filter(x => !!x) as Record[])
                }, null, 8, ["records"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(Footer),
      (showTokenSelectorDialog.value)
        ? (_openBlock(), _createBlock(TokenSelectorDialog, {
            key: 1,
            "eligible-burn-tokens": eligibleBurnTokens.value,
            onClose: _cache[0] || (_cache[0] = ($event: any) => {showTokenSelectorDialog.value = false;}),
            onCheckout: openConfirmationModal,
            onSelectedTokens: _cache[1] || (_cache[1] = ($event: any) => (selectedTokens.value = $event))
          }, null, 8, ["eligible-burn-tokens"]))
        : _createCommentVNode("", true),
      (showConfirmationModal.value)
        ? (_openBlock(), _createBlock(ConfirmDialog, {
            key: 2,
            steps: steps.value,
            "number-to-redeem": _unref(numberToRedeem),
            "redeem-token-name": __props.redeemAssetMetadata.name || '',
            "redeem-token-image": props.burnRedeemStudioInstance?.publicData?.redeemAssetMedia
        || __props.redeemAssetMetadata.image
        || __props.redeemAssetMetadata.animation_url
        || ''
      ,
            "selected-tokens": selectedTokens.value,
            onBurn: _unref(mutateBurnRedeem),
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmationModal.value = false))
          }, null, 8, ["steps", "number-to-redeem", "redeem-token-name", "redeem-token-image", "selected-tokens", "onBurn"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})